import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from '../logger/logger.service';
import { ErrorService } from '../service/error-service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(
        private loggerService: LoggerService,
        private errorService: ErrorService
    ) { }

    handleError(error: any) {
        if (error instanceof HttpErrorResponse) {
            if (error.error instanceof ErrorEvent) {
                // A.1: A client-side or network error occurred. Handle it accordingly.
                if (!navigator.onLine) {
                    // No Internet connection
                    this.loggerService.log('Network issue');
                } else {
                    this.errorService.log(error);
                    // Show notification to the user
                    this.loggerService.log(`${error.status} - ${error.message}`);
                }
            } else {
                // A.2: The API returned an unsuccessful response (i.e., 400, 401, 403, etc.).
                /**
                 * The [HttpService] should return a response that is consumable by the caller
                 * of the API. The response should include relevant information and error messages
                 * in a format that is known and consumable by the caller of the API.
                 */
                this.errorService.log(error);
                // Show notification to the user
                this.loggerService.log(`${error.status} - ${error.message}`);
            }
        } else {
            // Client Error Happend
            this.errorService.log(error);
            this.loggerService.log('Client Error. Please try after sometime.');
        }
    }
}
